import { Link } from "react-router-dom";
import { siteConfig } from "@/mocks/siteConfig";

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20minimalist%20technology%20background%20with%20soft%20flowing%20gradient%20shapes%20in%20warm%20cream%20and%20soft%20gray%20tones%2C%20clean%20geometric%20patterns%2C%20modern%20digital%20platform%20atmosphere%2C%20subtle%20depth%20and%20texture%2C%20no%20text%2C%20professional%20corporate%20aesthetic&width=1800&height=900&seq=mogu-hero-bg&orientation=landscape"
          alt="mogu 平台"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/10 to-black/20" />
      </div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-6 text-center">
        <span className="inline-block px-4 py-1.5 text-xs font-medium rounded-full bg-white/20 backdrop-blur-sm text-white mb-6 whitespace-nowrap">
          {siteConfig.tagline}
        </span>
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-6">
          探索 <strong className="font-bold">{siteConfig.name}</strong> 的一切
        </h1>
        <p className="text-base md:text-lg text-white/80 max-w-2xl mx-auto mb-10 leading-relaxed">
          想了解 {siteConfig.name}？本页为你全面解析 {siteConfig.name}
          的核心价值、使用场景与最新资讯，帮助你快速掌握 {siteConfig.name}{" "}
          相关知识，找到最适合你的 {siteConfig.name} 解决方案，立即开始探索。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/tutorial"
            className="px-8 py-3 text-sm font-medium rounded-full bg-white text-foreground-950 hover:bg-white/90 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            开始探索
          </Link>
          <Link
            to="/about"
            className="px-8 py-3 text-sm font-medium rounded-full border border-white/30 text-white hover:bg-white/10 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            了解更多
          </Link>
        </div>

        <div className="mt-14 grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-10">
          {[
            { value: "100万+", label: "活跃用户" },
            { value: "50+", label: "功能模块" },
            { value: "99.9%", label: "服务可用率" },
            { value: "200+", label: "企业客户" },
          ].map((stat) => (
            <div key={stat.label} className="text-center">
              <p className="text-2xl md:text-3xl font-bold text-white">{stat.value}</p>
              <p className="text-sm text-white/60 mt-1">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}